// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f4a3e6c","453":"7e4838f3","455":"fcbf568a","977":"05a5b9a6"}[chunkId] + ".chunk.js";
};